import React from 'react'
import { connect } from 'react-redux'
import { getCurrentQuestion } from '../selectors.js'
import IconInfo from 'react-icons/lib/md/info-outline'
import Tooltip from './Tooltip.js'
import './Question.css'

const Question = ({ question: { body, description } }) => {
  const { fontSize, lineHeight } = getFontSize(body)
  const style = { fontSize, lineHeight }
  const InfoIcon = description && <IconInfo size={16} />
  const Q = (
    <div className="Question">
      <div style={style}>
        {body}
        {InfoIcon}
      </div>
    </div>
  )
  if (description) return <Tooltip title={description}>{Q}</Tooltip>
  return Q
}

function getFontSize(question) {
  if (question.length <= 80) return {}
  if (question.length <= 150)
    return {
      fontSize: '0.9em',
      lineHeight: '1.3em',
    }
  return {
    fontSize: '0.8em',
    lineHeight: '1.2em',
  }
}

const mapStateToProps = state => ({
  question: getCurrentQuestion(state),
})

export default connect(mapStateToProps)(Question)



// WEBPACK FOOTER //
// ./src/components/Question.js